import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './neon-bite-food-Delivery.css';
import toDoListImage from '../../../assets/images/neonbite.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Neon Bite <span>Food Delivery</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 11th July 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">Neon Bite</h2>
          <span className="project-category">Website</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="neonBite" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://neon-bite.netlify.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Food-Delivery" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "neonBite",
                title: "Neon Bite Food Delivery",
                path: "/projects/projectdetail/neon-bite-food-Delivery"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
           Welcome to <strong>Neon-Bite</strong>! Here's a detailed overview of the Food Delivery Website.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>Neon-Bite Food Delivery</strong> website provides users with a modern platform to discover restaurants, browse delicious food, add items to the cart, and experience a smooth online ordering interface. The application is fully responsive and designed to deliver an engaging user experience across all devices.
          </p>

          <h3 className="section-title">Key Features of the App 🛠️</h3>
          <ul className="feature-list">
            <li><strong>Modern Hero Section</strong> 🍔 - Eye-catching landing page with food promotions.</li>
            <li><strong>Restaurant Listings</strong> 🍽️ - Browse popular restaurants and cuisines.</li>
            <li><strong>Food Categories</strong> 🍕 - Explore pizza, burgers, desserts, drinks, and more.</li>
            <li><strong>Search Functionality</strong> 🔍 - Quickly find your favorite meals.</li>
            <li><strong>Shopping Cart</strong> 🛒 - Add, remove, and update food items.</li>
            <li><strong>Responsive Design</strong> 📱 - Works perfectly on mobiles, tablets, and desktops.</li>
            <li><strong>Offers Section</strong> 🎁 - View exclusive discounts and deals.</li>
          </ul>

          <h3 className="section-title">How the Website Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Browse Restaurants</strong> 🍽️ - Explore available restaurants.</li>
            <li><strong>Select Food</strong> 🍕 - Choose delicious meals.</li>
            <li><strong>Add to Cart</strong> 🛒 - Manage your order easily.</li>
            <li><strong>Checkout</strong> 💳 - Review and place your order.</li>
          </ul>

          <h3 className="section-title">Features and Benefits 🚀</h3>
          <ul className="benefits-list">
             <li><strong>Fast Ordering</strong> ⚡ - Easy food ordering experience.</li>
             <li><strong>Clean Interface</strong> 🎨 - Attractive modern UI.</li>
             <li><strong>Responsive Layout</strong> 📱 - Seamless experience on every device.</li>
             <li><strong>Improved User Experience</strong> 🚀 - Interactive food browsing.</li>
          </ul>

          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
              <li><strong>Frontend</strong> 🖥️ - React, HTML5, CSS3, JavaScript.</li>
              <li><strong>Animations</strong> ✨ - Framer Motion.</li>
              <li><strong>Responsive Layout</strong> 📱 - CSS Flexbox & Grid.</li>
              <li><strong>Deployment</strong> ☁️ - Netlify / GitHub Pages.</li>
          </ul>

          <h3 className="section-title">Real-Life Applications 🌍</h3>
          <ul className="real-life-applications-list">
            <li><strong>Restaurant Websites</strong> 🍽️ - Showcase menus online.</li>
            <li><strong>Food Delivery Platforms</strong> 🚚 - Online ordering systems.</li>
            <li><strong>Cloud Kitchens</strong> 👨‍🍳 - Digital food businesses.</li>
            <li><strong>Café Websites</strong> ☕ - Promote cafes and bakeries.</li>
          </ul>

          <h3 className="section-title">Future Features 🔮</h3>
          <ul className="future-features-list">
            <li><strong>User Login</strong> 🔐 - Personalized accounts.</li>
            <li><strong>Live Order Tracking</strong> 📍 - Track deliveries in real time.</li>
            <li><strong>Online Payment</strong> 💳 - Secure payment integration.</li>
            <li><strong>AI Food Recommendations</strong> 🤖 - Smart personalized suggestions.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>The <strong>Neon-Bite Food Delivery</strong> website provides a modern and responsive food ordering experience with restaurant listings, interactive menus, shopping cart functionality, and attractive UI components. It demonstrates responsive web development, reusable components, and modern front-end design principles.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
